import React, { useState, useCallback } from "react";
import clsx from "clsx";

import { ReasonItem } from "./ReasonItem";
import CheckIcon from "../icons/tick.svg";

export const ReasonColumn = ({ column, onChange }) => {
  const [newReason, setNewReason] = useState("");
  const handleDelete = useCallback(
    (id) => {
      const updated = column.reasons.map((r) =>
        r.id === id ? { ...r, deactivated: true } : r
      );
      onChange(updated);
    },
    [column.reasons, onChange]
  );

  const handleUndo = useCallback(
    (id) => {
      const updated = column.reasons.map((r) =>
        r.id === id ? { ...r, deactivated: false } : r
      );
      onChange(updated);
    },
    [column.reasons, onChange]
  );

  const addReason = useCallback(() => {
    const text = newReason.trim();
    if (!text) return;
    const reason = {
      id: null,
      text,
      deactivated: false,
      isFromApi: false,
    };
    onChange([reason, ...column.reasons]);
    setNewReason("");
  }, [newReason, column.reasons, onChange]);

  const handleInputChange = useCallback((e) => {
    setNewReason(e.target.value);
  }, []);

  const handleKeyDown = useCallback(
    (e) => {
      if (e.key === "Enter") addReason();
    },
    [addReason]
  );

  return (
    <section className="reason-column">
      <header
        className={clsx(
          "reason-column__header",
          column.id === "mdo-accept" && "reason-column__first",
          column.id === "om-reject" && "reason-column__last"
        )}
      >
        {column.title}
      </header>
      <div className="reason-column__list">
        {column.reasons.map((r) => (
          <ReasonItem
            key={r.id}
            reason={r}
            onDelete={handleDelete}
            onUndo={handleUndo}
          />
        ))}
        <div className="add-row">
          <input
            id="new-reason-input"
            className={clsx("add-row__input")}
            placeholder="+ Add New Reason"
            value={newReason}
            onChange={handleInputChange}
            onKeyDown={handleKeyDown}
          />
          <button className="reason-action-button" onClick={addReason}>
            <img
              src={CheckIcon}
              alt="Add"
              className="reason-action-button-icon"
            />
          </button>
        </div>
      </div>
    </section>
  );
};
